import * as React from 'react';

import { Item, useCart } from 'react-use-cart';

import { getMoneyString } from '@commonTuna/react/components/Utils';

import '@app/scss/components/addToCartButton.scss';

interface Props {
	item: any;
	withTotal?: boolean;
}

const AddToCartButton: React.FC<Props> = (props) => {
	const {getItem, addItem, updateItemQuantity} = useCart();
	const item: Item = getItem(props.item.id);
	
	const withTotal = props.withTotal ?? true;

	const getQuantityTitle = (quantity: number) => {
		if (quantity > 1) {
			return `${quantity} units`;
		}
		return `${quantity} unit`;
	};
	
	const quantity = React.useMemo(() => item?.quantity, [item?.quantity]);
	
	return <div className="add-to-cart-btn">
		{quantity ?
			<div className="quantity-btn">
				<button className="quantity-btn__action" onClick={() => updateItemQuantity(item.id, quantity - 1)}>&ndash;</button>
				<div className="quantity-btn__title">
					<div className="unit">{getQuantityTitle(quantity)}</div>
					{withTotal && <div>{getMoneyString(item.itemTotal || 0)}</div>}
				</div>
				<button className="quantity-btn__action" onClick={() => updateItemQuantity(item.id, quantity + 1)}>+</button>
			</div>
			: <button className="add-special-btn" onClick={() => addItem(props.item, 1)}>Add to cart</button>
		}
	</div>;
};

export default AddToCartButton;